import React, { useEffect, useState } from 'react';
import { useNTBBannerQuery } from '../../../hooks';
import { View } from 'native-base';
import { NTBCashOutBannerWithoutSavings, NTBCashOutBannerWithSavings } from '../../molecules';
import { logUserEvent } from 'fmc-digital-common';
import { isEmpty } from 'lodash';
const LoanBanner = ({
  isNtbRequired = false,
  loanNumber = ''
}) => {
  const {
    data,
    status
  } = useNTBBannerQuery({
    isNtbRequired,
    loanNumber
  });
  //@ts-ignore
  const [isLoanBannerNeeded, setIsLoanBannerNeeded] = useState(false);
  const [loanBannerType, setLoanBannerType] = useState('');
  //@ts-ignore
  const selectNTBBannerToDisplay = () => {
    if (data?.ntbCalulationResult?.eligible && data?.ntbCalulationResult?.ntbType === 'Cashout') {
      if (data?.ntbCalulationResult?.monthlySaving > 0) {
        setIsLoanBannerNeeded(true);
        setLoanBannerType('COWithSavings');
      } else if (data?.ntbCalulationResult?.monthlySaving === 0) {
        setIsLoanBannerNeeded(true);
        setLoanBannerType('COWithoutSavings');
      }
    } else if (!data?.ntbCalulationResult?.eligible) {
      setIsLoanBannerNeeded(false);
    }
  };
  useEffect(() => {
    if (status === 'success' && !isEmpty(data)) {
      selectNTBBannerToDisplay();
    } else if (status === 'error') {
      logUserEvent({
        action: 'ErrorSavingsTextNotDisplayed',
        type: 'ErrorSavingsTextNotDisplayed',
        description: 'Error: Monthly Savings Text Failed to Display'
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, status, loanNumber]);
  return isLoanBannerNeeded ? /*#__PURE__*/React.createElement(View, {
    m: 4,
    mt: {
      md: '0',
      lg: '-10',
      xl: '-84'
    },
    alignSelf: "center",
    accessibilityLabel: "loanBanner",
    "data-testid": "loanBanner"
  }, loanBannerType === 'COWithSavings' ? /*#__PURE__*/React.createElement(NTBCashOutBannerWithSavings, data) : loanBannerType === 'COWithoutSavings' ? /*#__PURE__*/React.createElement(NTBCashOutBannerWithoutSavings, data) : null) : null;
};
export default LoanBanner;
//# sourceMappingURL=LoanBanner.js.map